import { NgModule } from '@angular/core';
import { TrustHtmlPipe } from './trust-html.pipe';
import { FormatDatePipe } from './format-date.pipe';
import { TranslateSystemCodePipe } from './translate-system-code.pipe';
import { OrganizationPipe } from './organization.pipe';
@NgModule({
	declarations: [TrustHtmlPipe, FormatDatePipe, TranslateSystemCodePipe, OrganizationPipe],
	imports: [],
	exports: [TrustHtmlPipe,FormatDatePipe, TranslateSystemCodePipe, OrganizationPipe]
})
export class PipesModule {}
